import React, { useLayoutEffect } from 'react';

import { clsx } from 'clsx';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';

import { CardsData } from './../../constants';
import Card from './Card';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import styles from './Cards.scss';

const Cards = () => {
  const { isDesktop } = useLayoutContext();

  useLayoutEffect(() => {
    const cardsTimeline = gsap.timeline({});
    const textTimeline = gsap.timeline({});

    ScrollTrigger.create({
      trigger: '#cards_container',
      start: isDesktop ? '600px center' : '500px center',
      end: '+=1000',
      pin: true,
      scrub: true,
      animation: cardsTimeline,
    });

    ScrollTrigger.create({
      trigger: '#cards_block_text',
      start: '300px center',
      scrub: true,
      animation: textTimeline,
    });

    for (let i = 1; i < CardsData.length; i++) {
      gsap.set(`#${CardsData[i].id}`, { y: 400 });
      cardsTimeline
        .to(
          `#${CardsData[i].id}`,
          { y: isDesktop ? CardsData[i].y1 : CardsData[i].mobileY1 },
          '+=0.0005'
        )
        .to(
          `#${CardsData[i - 1].id}`,
          { scale: 0.8, y: isDesktop ? CardsData[i - 1].y2 : CardsData[i - 1].mobileY2 },
          '<'
        );
    }

    gsap.set('#cards_block_text', { display: 'block' });
    textTimeline.to('#cards_block_text', { y: -50, opacity: 0 }, '+=0.2');
  }, []);

  return (
    <div className={styles.cardsBlock} id="cards_container">
      <div id="cards_block_text">
        <FadeIn className={styles.title} delay={0.2}>
          <span className={clsx(styles.title, styles.titleThin)}>We </span>change
        </FadeIn>
        <FadeIn delay={0.4} className={clsx(styles.title, styles.titleThin)}>
          the way you travel
        </FadeIn>
      </div>
      <FadeIn delay={0.6} className={styles.cardsContainer}>
        {CardsData.map((card) => (
          <Card card={card} key={card.id} />
        ))}
      </FadeIn>
    </div>
  );
};

export default Cards;
